
import { NgModule } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms'
import { Component, OnInit } from '@angular/core';
import { PartnerService } from '../../services/partner.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
@Component({
    selector: 'app-corporate-partner',
    templateUrl: './corporate-partner.component.html',
    styleUrls: ['./corporate-partner.component.scss']
})

export class CorporatePartnerComponent implements OnInit {
    statusMessage: string = "Loading data please wait...";
    partners: Observable<any>;
    isPageEditable: boolean = true;
    isDisplayPartnerList: boolean = true;
    isDisplayAddPartner: boolean = false;
    isDisplayUpdatePartner: boolean = false;
    isDisplayMultipleBtn: boolean = true;
    isDisplayupdateBtn: boolean = false;
    partnerForm: FormGroup;
    private formSubmitAttempt: boolean;
    logoImageFile: File;
    //logoImageFile: any[]=[];
    addressList = [];
    //addressform:{};
    addressform: FormGroup;
    isDisplayaddressform: boolean = false;
    isHideSubmmitbutton: boolean = false;
    registertionImage: any
    Partnersusers: Observable<any>;
    searchValues: any
    Previuesearch: any
    isSlide: boolean = false;
    constructor(private _partnerService: PartnerService, private router: Router, private fb: FormBuilder) {
        this.partnerForm = fb.group({
            partnerId: ['',],
            partnerTypeId: ['',],
            name: ['', [Validators.required]],
            description: ['', []],
            address: ['', [Validators.required]],
            location: ['', [Validators.required]],
            countrycode1: ['', []],
            contact1: ['', [Validators.required]],
            countrycode2: ['', []],
            contact2: [''],
            operatinghours: [''],
            logourl: [''],
            contact3: [''],
            username: ['', [Validators.required]],
            password: ['', [Validators.required]],

        })

        this.addressform = fb.group({
            addressId: ['',],
            address: ['', [Validators.required]],
            location: ['', [Validators.required]],
            countrycode1: ['', []],
            contact1: ['', [Validators.required]],
            countrycode2: ['', []],
            contact2: [''],
            operatinghours: [''],
            logourl: [''],
            contact3: [''],
            username: [''],
            password: [''],
        })

    }
    ngOnInit() {
        this.getPartnerList();
    }
    getPartnerList() {
        this._partnerService.getPartners()
            .subscribe(
                (employeeData) => {
                    if (employeeData == null) {
                        this.statusMessage = "Employee Id does not exist..";
                    }
                    else {
                        this.partners = employeeData.response.partnerList;
                        this.Partnersusers = employeeData.response.partnerList;
                    }
                    console.log(this.partners);
                },
                (error) => {
                    this.statusMessage = "Problem with the service. Please try again after sometime";
                    console.log(error);
                }

            );
    }

    showAdd() {
        this.partnerForm.reset();
        this.addressform.reset();
        this.addressList = [];
        this.isDisplayAddPartner = true;
        this.isDisplayPartnerList = false;
        this.isDisplayUpdatePartner = false;
    }

    showUpdate(partnerDetails) {
        this.addressform.reset();
        this.isDisplayUpdatePartner = true;
        this.isDisplayAddPartner = false;
        this.isDisplayPartnerList = false;
        this.registertionImage = partnerDetails.logoUrl;

        this.partnerForm.controls['partnerTypeId'].setValue(partnerDetails.partnerTypeId);

        this.partnerForm.controls['partnerId'].setValue(partnerDetails.partnerId);
        this.partnerForm.controls['name'].setValue(partnerDetails.partnerName);
        this.partnerForm.controls['description'].setValue(partnerDetails.description);
        this.addressList = partnerDetails.addressList;
    }


    cancelForm() {
        this.isDisplayUpdatePartner = false;
        this.isDisplayAddPartner = false;
        this.isDisplayPartnerList = true;
        this.formSubmitAttempt = false;
    }

    addPartner(partnerForm) {
        this.formSubmitAttempt = true;
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        this.partnerForm.value.addressList = this.addressList;
        this.partnerForm.value.token = loginUser.token;
        this.partnerForm.value.partnertypeid = (partnerForm.value.partnerTypeId == null || partnerForm.value.partnerTypeId == '') ? 1 : partnerForm.value.partnerTypeId;
        this.partnerForm.value.logoImage = this.logoImageFile;

        //// New Code 20Sept2019 Start
        this.partnerForm.value.name = partnerForm.value.name;
        this.partnerForm.value.address = partnerForm.value.address
        this.partnerForm.value.contact1 = partnerForm.value.contact1
        this.partnerForm.value.contact2 = partnerForm.value.contact2
        this.partnerForm.value.countrycode1 = '254';
        this.partnerForm.value.countrycode2 = '254';
        this.partnerForm.value.location = partnerForm.value.location
        this.partnerForm.value.operatinghours = partnerForm.value.operatinghours
        //this.partnerForm.value.operatinghours =
        this.partnerForm.value.partnerTypeId = (partnerForm.value.partnerTypeId == null || partnerForm.value.partnerTypeId == '') ? 1 : partnerForm.value.partnerTypeId;
        this.partnerForm.value.username = partnerForm.value.username
        this.partnerForm.value.password = partnerForm.value.password
        this.partnerForm.value.addressList = JSON.stringify(this.addressList)
        //// New code 20Sept End
        if (partnerForm.invalid) {
            return;
        } else {
            this._partnerService.addPartner(this.partnerForm.value).subscribe(
                data => {
                    if (data.returnCode == 0) {
                        alert("Partner records save Sucessfully")
                        this.getPartnerList();
                        this.partnerForm.reset();
                        this.formSubmitAttempt = false;
                        this.isDisplayAddPartner = false;
                        this.isDisplayPartnerList = true;
                        this.addressList = [];
                    }
                    else {
                        alert(data.returnMsg)

                    }
                },
                error => {
                    // this.alertService.error(error);
                    // this.loading = false;         
                    alert(error)
                    console.log(error)
                });
        }
    }

    addaddressForm(formValues) {
        this.addressList.push({
            "address": formValues.controls.address.value,
            "contact1": formValues.controls.contact1.value,
            "contact2": formValues.controls.contact2.value,
            "countrycode1": formValues.controls.countrycode1.value,
            "countrycode2": formValues.controls.countrycode2.value,
            "location": formValues.controls.location.value,
            "operatinghours": formValues.controls.operatinghours.value,
            "operatingHours": formValues.controls.operatinghours.value

        })
        this.addressform.reset();
        this.isDisplayaddressform = false;
        this.isHideSubmmitbutton = false;
    }

    DisplayAddressForm(partnerForm) {
        this.formSubmitAttempt = true;
        if (partnerForm.invalid) {
            return;
        }
        else {
            this.addressform.reset();
            this.isDisplayaddressform = true;
            this.isHideSubmmitbutton = true;
            this.isDisplayMultipleBtn = true;
            this.isDisplayupdateBtn = false;
            this.formSubmitAttempt = false;
        }
    }

    DisplayUpdateAddressForm() {

        this.addressform.reset();
        this.isDisplayaddressform = true;
        this.isHideSubmmitbutton = true;
        this.isDisplayMultipleBtn = true;
        this.isDisplayupdateBtn = false;
        this.formSubmitAttempt = false;
    }
    HideAddressForm() {
        this.isDisplayaddressform = false;
        this.isHideSubmmitbutton = false;
        this.isDisplayMultipleBtn = true;
        this.isDisplayPartnerList = false;
        this.formSubmitAttempt = false;
    }

    deletePartner(partnerDetails) {
        let confimationMessage = "Are you sure want to Delete " + partnerDetails.partnerName;
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        partnerDetails.token = loginUser.token;
        partnerDetails.id = partnerDetails.partnerId;
        if (confirm(confimationMessage)) {
            this._partnerService.deletePartner(partnerDetails).subscribe(
                data => {
                    if (data.returnCode == 0) {
                        alert("Record updated sucessfully")
                        this.getPartnerList();
                    }
                    else {
                    }
                },
                error => {
                    alert(error)
                    console.log(error)
                });

        }
        else {
            this.getPartnerList();
        }
    }

    editAddress(addressDetails) {

        this.addressform.reset();
        if (this.isDisplayUpdatePartner) {

            this.addressform.controls['addressId'].setValue(addressDetails.addressId);
            this.addressform.controls['address'].setValue(addressDetails.address);
            this.addressform.controls['location'].setValue(addressDetails.location);
            this.addressform.controls['contact1'].setValue(addressDetails.contact1);
            this.addressform.controls['contact2'].setValue(addressDetails.contact2);
            this.addressform.controls['operatinghours'].setValue(addressDetails.operatingHours);
            this.addressform.controls['password'].setValue(null);
            this.addressform.controls['username'].setValue(addressDetails.userName);
        }
        this.isDisplayaddressform = true;
        this.isHideSubmmitbutton = true;
        this.isDisplayMultipleBtn = false;
        this.isDisplayupdateBtn = true;

    }

    deleteAddress(addressDetails) {
        let confimationMessage = "Are you sure want to Delete " + addressDetails.address;
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        addressDetails.token = loginUser.token;
        addressDetails.id = addressDetails.addressId;
        addressDetails.isdeleteaddress = true;
        if (confirm(confimationMessage)) {
            this._partnerService.deletePartner(addressDetails).subscribe(
                data => {
                    if (data.returnCode == 0) {
                        alert("Record updated sucessfully")
                        this.addressList.forEach((item, index) => {
                            if (item.addressId == addressDetails.addressId) {
                                this.addressList.splice(index, 1)
                            }
                        });
                    }
                    else {
                    }
                },
                error => {
                    alert(error)
                    console.log(error)
                });

        }
        else {
            this.getPartnerList();
        }
    }

    updateAddress(addressDetails) {
        this.addressform.invalid;
        if (addressDetails.value.addressId && this.addressform.invalid == false) {
            this.addressList.forEach((item, index) => {
                if (item.addressId == addressDetails.value.addressId) {
                    this.addressList[index].address = addressDetails.value.address
                    this.addressList[index].location = addressDetails.value.location
                    this.addressList[index].contact1 = addressDetails.value.contact1
                    this.addressList[index].contact2 = addressDetails.value.contact2
                    this.addressList[index].operatingHours = addressDetails.value.operatinghours
                    this.addressList[index].operatinghours = addressDetails.value.operatinghours
                    this.addressList[index].username = addressDetails.value.username
                    this.addressList[index].password = addressDetails.value.password
                }
            });
        }
        else if (this.addressform.invalid == false) {
            this.addressList.push({
                "address": addressDetails.value.address,
                "contact1": addressDetails.value.contact1,
                "contact2": addressDetails.value.contact2,
                "location": addressDetails.value.location,
                "operatinghours": addressDetails.value.operatinghours,
                "operatingHours": addressDetails.value.operatinghours,
                "countryCode1": '254',
                "countryCode2": '254',
                "countrycode1": '254',
                "countrycode2": '254',
            })
        }
        this.isDisplayaddressform = false;
        this.isDisplayMultipleBtn = true;
        this.isHideSubmmitbutton = false;
    }

    updatePartner(partnerDetails) {

        this.formSubmitAttempt = true;
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        this.partnerForm.value.token = loginUser.token;
        this.partnerForm.value.addressList = this.addressList;
        this.partnerForm.value.address = this.addressList[0].address;
        this.partnerForm.value.location = this.addressList[0].location;
        this.partnerForm.value.contact1 = this.addressList[0].contact1;
        this.partnerForm.value.contact2 = this.addressList[0].contact2;
        this.partnerForm.value.operatinghours = this.addressList[0].operatinghours;
        this.partnerForm.value.operatingHours = this.addressList[0].operatinghours;

        partnerDetails.value.partnertypeid = (partnerDetails.value.partnerTypeId == null || partnerDetails.value.partnerTypeId == '') ? 1 : partnerDetails.value.partnerTypeId;
        this._partnerService.updatePartner(this.partnerForm.value).subscribe(
            data => {
                if (data.returnCode == 0) {
                    alert("Partner records save Sucessfully")
                    this.formSubmitAttempt = false;
                }
                else {
                    alert(data.returnMsg)

                }
            },
            error => {
                alert(error)
                console.log(error)
            });
        this.getPartnerList();
    }

    processFile(imageInput: any, event: any) {
        if (event.target.files && event.target.files[0]) {
            const reader = new FileReader();
            reader.onload = (event: ProgressEvent) => {
                this.registertionImage = (<FileReader>event.target).result;
            }
            this.logoImageFile = event.target.files[0];
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    searchPartner(searchValue) {
        if (searchValue) {
            this.partners = this.Partnersusers;
            this.partners = this.partners.filter(t => (t.partnerName != null && t.partnerName.toLowerCase().indexOf(searchValue) > -1) || (t.partnerType != null && t.partnerType.toLowerCase().indexOf(searchValue) > -1));

        }
        else {
            this.partners = this.Partnersusers;
        }
    }


    sideBarToggle() {
        if (this.isSlide) {
            this.isSlide = false;
        }
        else {
            this.isSlide = true;
        }

    }


}



// WEBPACK FOOTER //
// ./src/app/admin/corporate-partner/corporate-partner.component.ts